export const NEWS_TYPE = { TRAINING: 1, ANNOUNCEMENT: 2 };

// BE `status` kodları (docs/lms-news-status-fe-notu.txt)
export const NEWS_STATUS = { SCHEDULED: 1, UNPUBLISHED: 2, PUBLISHED: 3 };

export const NEWS_STATUS_I18N_KEY = {
    [NEWS_STATUS.SCHEDULED]: 'scheduled',
    [NEWS_STATUS.UNPUBLISHED]: 'unpublished',
    [NEWS_STATUS.PUBLISHED]: 'published'
};

export const NEWS_STATUS_SEVERITY = {
    [NEWS_STATUS.SCHEDULED]: 'warning',
    [NEWS_STATUS.UNPUBLISHED]: 'secondary',
    [NEWS_STATUS.PUBLISHED]: 'success'
};

export const NEWS_TITLE_MAX = 250;
export const NEWS_SHORT_DESCRIPTION_MAX = 500;

const PHOTO_EXTENSIONS = ['jpg', 'jpeg', 'png'];
const PHOTO_MIME_TYPES = ['image/jpeg', 'image/png'];
const PHOTO_MAX_BYTES = 10 * 1024 * 1024;
export const PHOTO_ACCEPT = '.jpg,.jpeg,.png,image/jpeg,image/png';

export const EMPTY_PHOTO_STATE = { file: null, removed: false };

export const validatePhotoFile = (file) => {
    if (!file) return null;
    const ext = (file.name || '').split('.').pop().toLowerCase();
    if (!PHOTO_EXTENSIONS.includes(ext) || (file.type && !PHOTO_MIME_TYPES.includes(file.type))) return 'lmsNews.form.photoTypeError';
    if (file.size > PHOTO_MAX_BYTES) return 'lmsNews.form.photoSizeError';
    return null;
};

export const isAnnouncement = (news) => Number(news?.newsType) === NEWS_TYPE.ANNOUNCEMENT;

export const getNewsTitle = (news) => (isAnnouncement(news) ? news?.title : news?.trainingName || news?.title) || '';

// BE UTC döner; "Z" eksikse yerel saat sanılmasın.
export const parseUtcDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);
    const date = new Date(hasZone ? value : `${value}Z`);
    return isNaN(date.getTime()) ? null : date;
};

// base.js'teki convertDatesToUTC tarihi yerel saat farkı kadar kaydırıyor; gerçek UTC gitsin diye önceden telafi edilir.
export const toApiUtcDate = (date) => {
    if (!date) return null;
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000).toISOString();
};

const pad = (n) => String(n).padStart(2, '0');

export const formatLocalDateTime = (value) => {
    const date = parseUtcDate(value);
    if (!date) return '';
    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatLocalDate = (value) => {
    const date = parseUtcDate(value);
    if (!date) return '';
    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
};

export const formatPlainDate = (value) => {
    if (!value) return '';
    const [y, m, d] = String(value).slice(0, 10).split('-');
    return y && m && d ? `${d}.${m}.${y}` : String(value);
};

const formatTime = (value) => (value ? String(value).slice(0, 5) : '');

export const formatTrainingDateRange = (news) => {
    if (!news?.startDate) return '';
    const start = [formatPlainDate(news.startDate), formatTime(news.startTime)].filter(Boolean).join(' ');
    if (!news.endDate) return start;
    const end = news.endDate === news.startDate ? formatTime(news.endTime) : [formatPlainDate(news.endDate), formatTime(news.endTime)].filter(Boolean).join(' ');
    return end ? `${start} – ${end}` : start;
};

export const formatFee = (news, freeLabel) => {
    if (!news?.isPaid) return freeLabel;
    const amount = Number(news.fee);
    const formatted = Number.isFinite(amount) ? amount.toLocaleString('tr-TR', { maximumFractionDigits: 2 }) : news.fee;
    return [formatted, news.currency].filter(Boolean).join(' ');
};

